export default "__VITE_ASSET__fUzq47UI__"